import LegalPage from '../components/ui/LegalPage.jsx'

export default function Contact() {
  return (
    <LegalPage
      title="Contact Us"
      description="Contact the FastAudio team with questions, support requests, or feedback. Fill in the form and we'll get back to you promptly."
      slug="contact"
    >
      <p>
        Have a question, suggestion, or need support? Fill out the form below and we'll get back
        to you as soon as possible.
      </p>

      <form
        className="mt-8 space-y-5 not-prose"
        onSubmit={e => { e.preventDefault(); alert('Message sent! We\'ll be in touch shortly.') }}
      >
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground mb-1.5">
            Name
          </label>
          <input
            id="contact-name"
            type="text"
            required
            placeholder="Your name"
            className="w-full px-4 py-2.5 rounded-xl border border-border bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40 text-sm"
          />
        </div>

        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground mb-1.5">
            Email
          </label>
          <input
            id="contact-email"
            type="email"
            required
            placeholder="you@example.com"
            className="w-full px-4 py-2.5 rounded-xl border border-border bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40 text-sm"
          />
        </div>

        <div>
          <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground mb-1.5">
            Subject
          </label>
          <input
            id="contact-subject"
            type="text"
            placeholder="How can we help?"
            className="w-full px-4 py-2.5 rounded-xl border border-border bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40 text-sm"
          />
        </div>

        <div>
          <label htmlFor="contact-message" className="block text-sm font-medium text-foreground mb-1.5">
            Message
          </label>
          <textarea
            id="contact-message"
            required
            rows={5}
            placeholder="Your message…"
            className="w-full px-4 py-2.5 rounded-xl border border-border bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40 text-sm resize-none"
          />
        </div>

        <button
          type="submit"
          className="px-6 py-2.5 rounded-xl bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors"
        >
          Send Message
        </button>
      </form>
    </LegalPage>
  )
}
